import { render } from "./DynamicForm.vue?vue&type=template&id=1f58337c&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&lang=ts"

import "./DynamicForm.vue?vue&type=style&index=0&id=1f58337c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f58337c"

export default script